import { FETCH_STATEMENTS, FETCH_REVENUE_BREAKDOWN } from '../actionTypes';

const initialState = {
  statements: [],
  breakdowns: []
};

export default function(state = initialState, action=null){
  switch (action.type) {
    case FETCH_STATEMENTS:
      return {
        revenues: action.payload.revenues,
      }
    case FETCH_REVENUE_BREAKDOWN:
      return {
        ...state,
        breakdowns: action.payload.breakdowns,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/statements.js